import { render, staticRenderFns } from "./FormDepositScreens.vue?vue&type=template&id=7b08edab&scoped=true&"
import script from "./FormDepositScreens.vue?vue&type=script&lang=js&"
export * from "./FormDepositScreens.vue?vue&type=script&lang=js&"
import style0 from "./FormDepositScreens.vue?vue&type=style&index=0&id=7b08edab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b08edab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
